<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jctmNI/tc-custom/9798891554832.jpg?1737196545493" alt="This image is the cover for the book The Arrow Academy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Arrow Academy
      </h1>
      <p class="bookDescription body article font2">
        <p>Adelaide Abbott never felt like she fit into her own life. She didn’t fit in with the other kids around her, and one day, it became clear why. After discovering she had a very special gift, her parents sent her to the Arrow Academy, a school for exceptional students. </p><p>She didn’t seem to fit in much their either. After being at the school for a while, she learned it had a secret that put the older students in danger. It was up to her and the Junior class men to save the day. But are they ready?</p><p>Join Adelaide, her older brother Isaac, mean girl Brooklynn, shy Jensen, charming Silas, wild Dylann, unpredictable Ian, and big Lincoln on an adventure none of them were prepared for.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vanessa Robinson, Shelby Nower
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;color:black;background:white;'>Vanessa Robinson is a young Indiana native and is passionate about writing and telling stories. She is pursuing a career in ministry and uses every opportunity to serve her church and community. Robinson is a dedicated wife, daughter, sister, and aunt. She wrote these stories for her nieces and nephews, to whom the book is dedicated.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fe8f531